// extracted by mini-css-extract-plugin
module.exports = {"container":"UserMenu_container__3dYTf","avatar":"UserMenu_avatar__1y2Bt","name":"UserMenu_name__35h4H"};